import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsErrores} from '../cls-errores';
import {ClsBorrarRegistro, ClsCatalogosExpIns2} from '../cls-catalogo-general';

export class ClsPeticionGuardarActualizarExpIns extends ClsPeticionPresupuestos {
  Catalogo: ClsCatalogosExpIns2[];
}

export class ClsRespuestaGuardarActualizarExpIns {
  ListaIds: bigint[];
  ListaIdsCodigo: any;
  Errores: ClsErrores;
}

export class ClsPeticionBorrarExpIns extends ClsPeticionPresupuestos {
  Validar: boolean;
  ListaIds: bigint[];
}

export class ClsRespuestaBorrarExpIns {
  Codigo: ClsBorrarRegistro[];
  Errores: ClsErrores;
}

export class ClsPeticionObtieneExpXConcepto extends ClsPeticionPresupuestos {
  IdCodigoMatriz: bigint;
}
